<template>
  <RevDrawer :name="MODAL_NAME" :title="i18n(translations.modalTitle)">
    <template #body="{ close }">
      <component
        :is="form"
        class="mb-16"
        :legal-details
        :legal-details-metadata
        @close-modal="close"
        @update-form="handleFormUpdated"
      />
    </template>
    <template #footer="{ close }">
      <RevButton
        id="edit_legal_details_button"
        class="mt-7"
        :form="formId"
        full-width="always"
        type="submit"
        variant="primary"
      >
        {{ i18n(translations.submitButton) }}
      </RevButton>
      <RevLink id="cancel_form" class="m-auto mt-12 w-full" @click="close">
        {{ i18n(translations.cancelButton) }}
      </RevLink>
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type {
  GetLegalDetailsMetadata,
  GetProfileViewLegalDetails,
} from '@backmarket/http-api/src/api-specs-seller-backoffice/seller-profile'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevDrawer } from '@ds/components/Drawer'
import { RevLink } from '@ds/components/Link'

import { FORM_IDS, MODAL_NAMES } from '../../../../../../Profile.constants'

import translations from './OverviewModal.translations'
// TODO make those components be imported dynamically at runtime
import AustraliaForm from './components/AustraliaForm/AustraliaForm.vue'
import DefaultForm from './components/DefaultForm/DefaultForm.vue'
import JapanForm from './components/JapanForm/JapanForm.vue'

const MODAL_NAME = MODAL_NAMES.EDIT_LEGAL_DETAILS

const FORM_COMPONENTS = {
  default: DefaultForm,
  japan: JapanForm,
  australia: AustraliaForm,
}

const props = defineProps<{
  legalDetails: GetProfileViewLegalDetails | null
  legalDetailsMetadata: GetLegalDetailsMetadata | null
  isMissingLegalDetails: boolean
}>()

const emit = defineEmits(['update-form'])

const i18n = useI18n()

const form = computed(
  () =>
    FORM_COMPONENTS[
      props.legalDetailsMetadata?.formType as keyof typeof FORM_COMPONENTS
    ],
)

const formId = computed(
  () =>
    FORM_IDS.EDIT_LEGAL_DETAILS[
      props.legalDetailsMetadata
        ?.formType as keyof typeof FORM_IDS.EDIT_LEGAL_DETAILS
    ],
)

function handleFormUpdated() {
  emit('update-form')
}
</script>
